import { render, staticRenderFns } from "./staticComponent.vue?vue&type=template&id=3f4e3171"
import script from "./staticComponent.vue?vue&type=script&lang=js"
export * from "./staticComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports